import { render } from "./footer.vue?vue&type=template&id=eaf241ac&scoped=true&ts=true"
import script from "./footer.vue?vue&type=script&lang=ts"
export * from "./footer.vue?vue&type=script&lang=ts"

import "./footer.vue?vue&type=style&index=0&id=eaf241ac&scoped=true&lang=scss"
import "./footer.vue?vue&type=style&index=1&id=eaf241ac&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eaf241ac"]])

export default __exports__